import React, { Component } from 'react';
import DocumentMeta from 'react-document-meta';
import 'bootstrap/dist/css/bootstrap.css';
import _debounce from 'lodash/debounce';
import {
	Container,
	Collapse,
	Navbar,
	NavbarToggler,
	NavbarBrand,
	Nav,
	NavItem,
	NavLink
} from 'reactstrap';

import logo from '../../assets/images/rhodes-logo.png';
import building from '../../assets/images/building-1.jpg';



export default class RhodesCRE extends Component {
	constructor(props) {
		super(props);
		this.state = {
			cvData: this.props.data,
			navbarStatus: 'fixed',
			fullName: '',
			email: '',
			phone: '',
			message: '',
		};
		this.handleEmailChange = this.handleEmailChange.bind(this);
		this.handleFullNameChange = this.handleFullNameChange.bind(this);
		this.handleMessageChange = this.handleMessageChange.bind(this);
		this.handlePhoneChange = this.handlePhoneChange.bind(this);
		this.handleScroll = _debounce(this.handleScroll.bind(this), 1);
	}

	componentDidMount() {
		window.addEventListener('scroll', this.handleScroll, true);
		const script = document.createElement("script");

		script.src = "//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js";
		script.async = true;

		document.body.appendChild(script);
	}

	componentWillUnmount() {
		// If this component is unmounted, stop listening
		window.removeEventListener('scroll', this.handleScroll, false);
	}

	handleEmailChange(evt) {
		this.setState({ email: evt.target.value });
	}

	handleFullNameChange(evt) {
		this.setState({ fullName: evt.target.value });
	}

	handleMessageChange(evt) {
		this.setState({ message: evt.target.value });
	}

	handlePhoneChange(evt) {
		this.setState({ phone: evt.target.value });
	}

	handleScroll(event) {
		const scrollTop = event.target.scrollTop;
		if (scrollTop > 119) {
			this.setState({ navbarStatus: 'relative'});
		} else {
			this.setState({ navbarStatus: 'fixed' });
		}
	}

	toggle = () => {
		this.setState({ navbarTogglerOpen: !this.state.navbarTogglerOpen });
	};

	render() {
		const meta = {
			title: 'Rhodes CRE',
			description: 'Simon rhodes CRE',
			canonical: 'https://a-m-j.co.uk/rhodescre',
			meta: {
				charset: 'utf-8',
				name: {
					keywords: 'simon rhodes, rhodescre'
				}
			}
		};
		return (
			<div>
				<DocumentMeta {...meta} />
				<Navbar expand="md"  style={{
					position: this.state.navbarStatus,
					display: this.state.navbarStatus === 'fixed' ? '' : 'none'
				}} className={this.state.navbarStatus === 'fixed' ? 'fixed-top' : ''}>
					<Container>
						<NavbarBrand href="#home">
							<img src={logo} alt="Logo" className="d-inline-block align-top" height="65px" />
						</NavbarBrand>
						<NavbarToggler onClick={this.toggle} />
						<Collapse isOpen={this.state.navbarTogglerOpen} navbar>
							<Nav className={`ml-auto ${this.state.navbarTogglerOpen ? 'show' : 'vertical'}`} navbar>
								<NavItem>
									<NavLink href="/">Back</NavLink>
								</NavItem>
							</Nav>
						</Collapse>
					</Container>
				</Navbar>

				<section id="home">
					<div className="section-image"
						style={{
							backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.45)),url(${building})`, backgroundSize: 'cover', filter: 'grayscale(100%)' }}>
					</div>
					<div className="slide-wrapper">
						<div className="slide-content">
							<div className="wrapper right">
								<h1>Aston Barclay motors into state-of-the-art new ‘mega centre’</h1>
								{/*<div className="button-group">
									<span>View more</span> <button type="button"></button>
								</div>*/}
							</div>

						</div>
					</div>
					<div className="section-base black">
						<div className="outer-triangle"></div>

						<div className="content">
							<div className="tag"></div>
							<p>National independent vehicle remarketing group, Aston Barclay, has opened a spectacular new West Yorkshire auction centre near Wakefield, with support from Rhodes CRE. </p>
							<p>Aston Barclay now has six strategically located auction centres throughout England, and Wakefield is the company’s second biggest UK base, dubbed  its ‘mega centre’.</p>
							<p>The site, formally known as Photon Park, is a brand-new facility comprising approximately 85,000 sq ft of accommodation set within a 16-acre site at Normanton, close to junction 31 of the M62 motorway.</p>
							<p>Rhodes CRE negotiated the lease terms with the site’s owner, Illuminating Investments, on Aston Barclay’s behalf, before advising the company with securing a change of use planning application and assisting with the substantial fit out requirements. </p>
							<p>Following completion of the works, the facility now offers twin glazed auction halls, vehicle preparation and appraisal areas, customer parking and storage for more than 2,500 vehicles, as well as a restaurant and gym. Approximately 50,000 vehicles are to be auctioned at the site each year creating up to 150 high grade jobs. </p>
							<p>Aston Barclay’s chief financial officer and commercial director, John Crichton, said “There is no other auction like Wakefield in the UK or Europe. It offers a five-star building with enough space to auction and store hundreds of cars both externally and undercover. It’s a stunning facility and the guidance that Rhodes CRE provided was invaluable in making our vision a reality.”</p>
							<p>Simon Rhodes, managing director of Rhodes CRE, said: “Following the success of this scheme, Illuminating Investments has now sold the investment, which speaks volumes about the building’s overall quality and the strength of Aston Barclay as a tenant.”</p>
							<p>David Aspland, director of Illuminating Investments, said: “What Aston Barclay and Rhodes CRE have achieved at Photon Park has been ground-breaking. It’s a superb facility that has also had a positive impact in the surrounding area, bolstering the local economy and creating new jobs.” </p>

						</div>
					</div>
				</section>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/scripts/pages/CaseStudy.js